import React from 'react'
import { connect } from 'react-redux'
import { logout } from 'ducks/app'
import { Menu, Dropdown, Avatar, Badge, Button } from 'antd'
import { changeLanguageEN, changeLanguageES, changeLanguagePORT } from '../../../../index'
import { createHashHistory } from 'history'
const history = createHashHistory()
const Translate = require('react-redux-i18n').Translate
const mapDispatchToProps = dispatch => ({
  logout: event => {
    event.preventDefault()
    dispatch(logout())
  },
  changeLangEN() {
    changeLanguageEN()
  },
  changeLangES() {
    changeLanguageES()
  },
  changeLangPORT() {
    changeLanguagePORT()
  },
  changePassword() {
    history.push('/changePassword')
  },
})

const mapStateToProps = (state, props) => ({
  userState: state.app.userState,
})

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class ProfileMenu extends React.Component {
  render() {
    const { userState, logout, changePassword } = this.props
    const menu = (
      <Menu selectable={false}>
        {/* <Menu.Item>
          <a onClick={changeLangEN}>
            <img src="resources/quqoImages/en.png" alt="Mediatec Software" /> Ingles
          </a>
          <a onClick={changeLangES}>
            <img src="resources/quqoImages/es.png" alt="Mediatec Software" /> Español
          </a>
        </Menu.Item> */}
        <Menu.Item>
          <div className="rfq__widget__system-status__item">
            <strong>
              <Translate value="application.email" />:
            </strong>{' '}
            {userState.email} <br />
            <div>
              <strong>Rol:</strong> {userState.role}
            </div>
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <Button type="primary" onClick={changePassword}>
            <Translate value="application.changePassword" />
          </Button>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a href="javascript: void(0);" onClick={logout}>
            <i className="topbar__dropdownMenuIcon icmn-exit" />
            <Translate value="application.SignOff" />
          </a>
        </Menu.Item>
      </Menu>
    )
    return (
      <div className="topbar__dropdown d-inline-block">
        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
          <a className="ant-dropdown-link" href="/">
            <Badge>
              <Avatar className="topbar__avatar" shape="square" icon="user" />
            </Badge>
          </a>
        </Dropdown>
      </div>
    )
  }
}

export default ProfileMenu



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/ProfileMenu/index.js